<template>
  <van-button :class="['my-button', size, type]" v-bind="$props">
    <slot />
  </van-button>
</template>

<script>
import { Button } from 'vant'
export default {
  components: {
    'van-button': Button
  },
  props: {
    ...Button.props,
    size: {
      type: String,
      default: 'normal'
    },
    type: {
      type: String,
      default: 'blue'
    }
  },
  methods: {}
}
</script>

<style scoped lang="less">
.my-button {
  width: 274px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: normal;
  letter-spacing: 2px;
  color: #fff;
  border: none;
}

.blue {
  background-color: #00a0ea;
}

.red {
  background-color: #e70012;
}

.gray {
  background-color: #dcdcdc;
}

.normal {
  height: 38px;
}

.large {
  height: 56px;
}
</style>
